var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1693 17.5V15.8333C14.1693 14.9493 13.8181 14.1014 13.193 13.4763C12.5678 12.8512 11.72 12.5 10.8359 12.5H4.16927C3.28522 12.5 2.43737 12.8512 1.81225 13.4763C1.18713 14.1014 0.835938 14.9493 0.835938 15.8333V17.5",
    stroke: "#9C9C9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4974 9.16667C9.33834 9.16667 10.8307 7.67428 10.8307 5.83333C10.8307 3.99238 9.33834 2.5 7.4974 2.5C5.65645 2.5 4.16406 3.99238 4.16406 5.83333C4.16406 7.67428 5.65645 9.16667 7.4974 9.16667Z",
    stroke: "#9C9C9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1641 17.4991V15.8324C19.1635 15.0939 18.9177 14.3764 18.4652 13.7927C18.0127 13.209 17.3792 12.7921 16.6641 12.6074",
    stroke: "#9C9C9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 2.60742C14.0529 2.79101 14.6885 3.20801 15.1423 3.79268C15.5961 4.37736 15.8425 5.09645 15.8425 5.83659C15.8425 6.57673 15.5961 7.29582 15.1423 7.8805C14.6885 8.46517 14.0529 8.88217 13.3359 9.06576",
    stroke: "#9C9C9C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.98eebdf2dec2340135f1f9fecda0ac36.svg";
export { ForwardRef as ReactComponent };